import {observer} from 'mobx-react-lite'
import React from 'react'
import {Lang} from 'yougile-lang'
import {Debouncer} from 'yougile-util'
import {PanelResizer} from '@components/right-panel/panel-resizer/panel-resizer'
import {
  resizeStore,
  timelineResizeStore
} from '@components/timeline-new/resize-store'
import {
  useTimelineConfig,
  useTimelineNewStore
} from '@components/timeline-new/timeline-new-store'

export const tableGaps = 16
// 16 - доп отступ справа при ресайзе
export const assignedColWidth = 52 + 16

// первая 8 это доп отступ от скролла
// вторая 8 это паддинг справа от названия
// третья 8 это гэп между названием и исполнителем
export const otherColumnsWidthStatic = 8 + 8 + 8 + 52 + 8 + 150 + 8 + 72
export const otherColumnsWidth = otherColumnsWidthStatic + 8 + 32

export const useOtherColumnsWidth = () => {
  const config = useTimelineConfig()
  return config.static ? otherColumnsWidthStatic : otherColumnsWidth
}

const debouncer = new Debouncer(10)

export const TitleHeader = observer(() => {
  const [state] = useTimelineNewStore()
  const otherColumnsWidth = useOtherColumnsWidth()

  const onStartResize = () => {
    state.tableScrollableEl?.classList.add('hide-rails')
    timelineResizeStore.setResizeTitle(true)
  }

  const onResize = (width: number) => {
    debouncer.runButNotOften(() => {
      timelineResizeStore.setTitleWidth(width)

      if (resizeStore.twTaskRef) {
        const twTaskRefWidth = parseInt(resizeStore.twTaskRef.style.width)
        const taskWidth = twTaskRefWidth || timelineResizeStore.getTasksWidth()

        const newWidth = width + assignedColWidth + tableGaps

        if (
          newWidth > taskWidth &&
          newWidth > resizeStore.intermediateTitleWidth
        ) {
          resizeStore.twTaskRef.style.width = newWidth + 'px'
          resizeStore.intermediateTitleWidth = newWidth
        }

        const maxWidth = width + otherColumnsWidth
        if (maxWidth < taskWidth) {
          resizeStore.twTaskRef.style.width = maxWidth + 'px'
          resizeStore.intermediateTitleWidth = maxWidth
        }
      }
    })
  }

  const onEndResize = (width: number) => {
    state.tableScrollableEl?.classList.remove('hide-rails')

    timelineResizeStore.setResizeTitle(false)
    timelineResizeStore.setTitleWidth(width)

    const maxWidth = width + otherColumnsWidth

    const taskWidth = timelineResizeStore.getTasksWidth()
    const newWidth = width + assignedColWidth + tableGaps
    if (
      newWidth >= taskWidth &&
      newWidth >= resizeStore.intermediateTitleWidth
    ) {
      timelineResizeStore.setTasksWidth(newWidth)
    } else if (resizeStore.intermediateTitleWidth > 0) {
      timelineResizeStore.setTasksWidth(resizeStore.intermediateTitleWidth)
    } else if (maxWidth < taskWidth) {
      timelineResizeStore.setTasksWidth(maxWidth)
    }

    // perfectScrollbarRef.current?.updateScroll()
    resizeStore.intermediateTitleWidth = 0
  }

  return (
    <div className="flex w-full">
      {Lang.msg.timeline.columnTitle}
      <div className="flex ml-auto max-h-10 items-center justify-center mr-[-10px]">
        <div className="h-48 relative">
          <PanelResizer
            type="right"
            offset="-right-[2px]"
            initialWidth={timelineResizeStore?.getTitleWidth()}
            minWidth={234}
            maxWidth={646}
            onStartResize={onStartResize}
            onResize={onResize}
            onEndResize={onEndResize}
            dragAllowed={true}
            dragged={timelineResizeStore.state.resizeTitle}
            placeholder
          />
        </div>
      </div>
    </div>
  )
})
